import React, { useState } from "react";

const ExpandableText = ({ text, limit = 200 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > limit;
  const displayText = expanded || !isLong ? text : text.slice(0, limit) + "…";

  return (
    <div>
      <p className="mb-2 fw-bolder">Коротко, о технике</p>
      <p className="summary-text">{displayText}
      {isLong && (
        <button
          className="btn btn-link p-0"
          style={{ fontSize: "0.9rem" }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Скрыть" : "Показать больше"}
        </button>
      )}
      </p>
    </div>
  );
};

export default ExpandableText;
